import { combineEpics, ofType } from "redux-observable";
import { mergeMap, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { observableFetchStream, observableGET } from "@/api/apiClient";
import {
  getAllChatbotConversationOfUserFailure,
  getAllChatbotConversationOfUserRequest,
  getAllChatbotConversationOfUserSuccess,
  getChatbotConversationsHistoryRequest,
  getChatbotConversationsHistorySuccess,
  getChatbotConversationsHistoryFailure,
  chatStreamRequest,
  chatStreamSuccess,
  chatStreamFailure
} from "./aiChatBot";

const getAllChatbotConversationOfUserEpic = (action$) =>
  action$.pipe(
    ofType(getAllChatbotConversationOfUserRequest.type),
    mergeMap((action) => {
      const { userId } = action.payload;
      return observableGET(`/chatbot/${userId}`).pipe(
        mergeMap((response) => {
          return of(getAllChatbotConversationOfUserSuccess(response.data));
        }),
        catchError((error) => of(getAllChatbotConversationOfUserFailure(error)))
      );
    })
  );

export const getChatbotConversationsHistoryEpic = (action$) =>
  action$.pipe(
    ofType(getChatbotConversationsHistoryRequest.type),
    mergeMap((action) => {
      const { page, size, sessionId } = action.payload;
      return observableGET(
        `/chatbot/messages?page=${page}&size=${size}&session_id=${sessionId}`
      ).pipe(
        mergeMap((response) =>
          of(getChatbotConversationsHistorySuccess(response.data))
        ),
        catchError((error) => of(getChatbotConversationsHistoryFailure(error)))
      );
    })
  );

export const postChatbotStreamEpic = (action$) =>
  action$.pipe(
    ofType(chatStreamRequest.type),
    mergeMap((action) => {
      return observableFetchStream(`/chatbot/stream`, "POST", {
        body: { ...action.payload },
        customHeader: { Accept: "text/event-stream" }
      }).pipe(
        mergeMap((response) => {
          return of(chatStreamSuccess(response));
        }),
        catchError((error) => of(chatStreamFailure(error)))
      );
    })
  );

const aiChatBotEpic = combineEpics(
  getAllChatbotConversationOfUserEpic,
  getChatbotConversationsHistoryEpic,
  postChatbotStreamEpic
);

export default aiChatBotEpic;
